import React, { useEffect, useRef } from 'react';

export default function ClusterReviewDialog({ title, busy, error, onClose, children }: {
  title: string; busy: boolean; error: string; onClose: () => void; children: React.ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    dialog?.showModal();
    return () => { dialog?.close(); };
  }, []);
  return <dialog ref={ref} className="review-dialog" aria-labelledby="review-dialog-title" onCancel={event => {
    event.preventDefault(); if (!busy) onClose();
  }}>
    <div className="review-dialog-heading"><h2 id="review-dialog-title">{title}</h2><button type="button" className="review-icon-button" aria-label="Pencereyi kapat" disabled={busy} onClick={onClose}>×</button></div>
    {error && <p className="review-error" role="alert">{error}</p>}
    {children}
  </dialog>;
}
